import { render, staticRenderFns } from "./TopSportsBarAmerican.vue?vue&type=template&id=1c494fd4&scoped=true"
import script from "./TopSportsBarAmerican.vue?vue&type=script&lang=js"
export * from "./TopSportsBarAmerican.vue?vue&type=script&lang=js"
import style0 from "./TopSportsBarAmerican.vue?vue&type=style&index=0&id=1c494fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c494fd4",
  null
  
)

export default component.exports